
document.addEventListener("DOMContentLoaded", function () {

	//variant.metafields カラー名表示
	// 初期表示
	var color_name = $('input[name="カラー"]:checked').next("label").data("color-name");
	$(".product__color-name ").append(color_name);

	// メインスライダー
	const main = new Splide("#main-carousel", {
		type: "fade", // フェード
		rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
		pagination: false, // ページネーション非表示
		arrows: false, // 矢印非表示
	});
	// サムネイル
	const thumbnails = new Splide("#thumbnail-carousel", {
		perPage: 5, // サムネイル3枚表示
		pagination: false, // ページネーション非表示
		isNavigation: true, // 他のスライダーのナビゲーションとしてそれぞれのスライドをクリック可能にする
	});
	main.sync(thumbnails);
	main.mount();
	thumbnails.mount();

	$('input[name="カラー"]').change(function () {
		if ($(this).is(":checked")) {
			var option_index = $(this).parent('li').index();
			var variant_size_index = $('[data-option="サイズ"] .list-variants > li').length;
			var option_no = option_index * variant_size_index;
			$(".product__color-name").empty();
			$(".product__color-name").append($(this).next("label").data("color-name"));
			$('[data-swiper-slide-index="0"]').find('img').attr('src', Shopify.product.variants[option_no].featured_image.src);
			main.go(0);
		}
	})

	/* ページ表示時の画像色をバリアント画像に */
	const listVariants = document.getElementsByClassName('list-variants');
	const listVariant = listVariants[0].getElementsByTagName('li');
	let checkNum = 0;
	for (let i = 0; i < listVariant.length; i++) {
		let listInput = listVariant[i].getElementsByTagName('input');
		if (listInput[0].checked) {
			checkNum = i;
		}
	}
	var variant_size_index = $('[data-option="サイズ"] .list-variants > li').length;
	var option_no = checkNum * variant_size_index;
	$('[data-swiper-slide-index="0"]').find('img').attr('src', Shopify.product.variants[option_no].featured_image.src);

});
